import React from 'react';
import { GRID } from '@/utils/constants';

export function trackStatusText(tracks = [], classSession = null, trackCount = tracks.length) {
  if (!classSession) return `Tracks: ${trackCount}`;
  if (classSession.phase === 'pick') {
    const packTracks = tracks.filter((track) => track.classSlot);
    const picked = packTracks.filter((track) => !track.muted && !track.inBank).length;
    return `Picked ${picked} of ${packTracks.length}`;
  }
  const picked = tracks.filter((track) => !track.inBank).length;
  const banked = tracks.filter((track) => track.inBank).length;
  return `Tracks: ${picked} · Sound bank ${banked}`;
}

export const StatusBar = ({ tracks = [], classSession = null, trackCount = tracks.length, currentBar = 1, activeTool = 'Select' }) => {
  const trackStatus = trackStatusText(tracks, classSession, trackCount);
  return (
    <div
      data-testid="status-bar"
      className="flex items-center justify-between px-4 border-t shrink-0 select-none"
      style={{
        height: GRID.STATUSBAR_HEIGHT,
        background: 'var(--bg-card)',
        borderColor: 'var(--border)',
      }}
    >
      <div className="flex items-center gap-4">
        <span style={{ fontSize: 11, fontWeight: 500, color: 'var(--text-dim)' }}>
          <span style={{ color: 'var(--text-secondary)' }}>{trackStatus}</span>
        </span>
        <span style={{ fontSize: 11, fontWeight: 500, color: 'var(--text-dim)' }}>
          Bar: <span style={{ color: 'var(--text-secondary)' }}>{currentBar}</span>
        </span>
        <span style={{ fontSize: 11, fontWeight: 500, color: 'var(--text-dim)' }}>
          Tool: <span style={{ color: 'var(--green)' }}>{activeTool}</span>
        </span>
      </div>
      <div className="flex items-center gap-2">
        <span style={{ fontSize: 10, fontWeight: 500, color: 'var(--text-dim)' }}>
          Beat Arranger
        </span>
        <span style={{ fontSize: 10, color: 'var(--text-dim)' }}>|</span>
        <span style={{ fontSize: 10, fontWeight: 500, color: 'var(--green)' }}>
          LTBB
        </span>
      </div>
    </div>
  );
};

export default StatusBar;
